import React, {lazy, Suspense} from 'react'

const ShopPageLazy = lazy(() =>
    import('./ShopPage')
)

const ShopPage = props => (
    <Suspense fallback={null}>
        <ShopPageLazy {...props} />
    </Suspense>
)

export default ShopPage
